import {
  Timestamp,
  collection,
  doc,
  getDocs,
  query,
  where,
  writeBatch,
} from "firebase/firestore";
import { db } from "shared/api/firebase";

type Params = {
  brandId: string;
  pageId: string;
  defaultPageType: "isDefaultForUnauthenticated" | "isDefaultForAuthenticated";
};

export const updateDefaultPage = async ({
  pageId,
  brandId,
  defaultPageType,
}: Params): Promise<void> => {
  const collectionRef = collection(db, `brands/${brandId}/pages`);

  const authenticatedQuery = query(
    collectionRef,
    where(defaultPageType, "==", true),
  );
  const snapshot = await getDocs(authenticatedQuery);

  const batch = writeBatch(db);

  const currentAuthDoc = snapshot.docs[0];
  if (currentAuthDoc && currentAuthDoc.id !== pageId) {
    batch.update(currentAuthDoc.ref, {
      [defaultPageType]: false,
      updatedAt: Timestamp.now(),
    });
  }

  const targetPageRef = doc(collectionRef, pageId);

  batch.update(targetPageRef, {
    [defaultPageType]: true,
    isActive: true,
    updatedAt: Timestamp.now(),
  });

  await batch.commit();
};
